import { map as _map, values as _values, size as _size } from 'lodash'
import ArrayHandler from './ArrayHandler'


const getActiveLabIndex = (currentLabID, lab) => {
  const numCurrentLabID = isNaN(currentLabID)
    ?
    currentLabID
    :
    Number(currentLabID);

  if (numCurrentLabID === getLabID(lab)) { return 0; }

  if (!lab.customized) {
    const arrID = lab.master.affiliated_products.map((affiliated) => (
      getLabID(affiliated)
    ));

    for (let i = 0; i < arrID.length; i++) {
      if (arrID[i] === numCurrentLabID) { return i + 1; }
    }
  }
};
const getExplanationData = (data) => {
  let result = _map(
      _values(data).filter((item) => (
          item && typeof item === 'object' && (('Explanation' in item && _size(item.Explanation) > 0)
              || ('Links' in item && _size(item.Links) > 0))
      )),
      (item, idx) => {
          const itemUpdated = {
              name: item.ChineseAccount,
              text: item.Explanation,
              order: item.Order || idx,
          };

          if (item.Links && _size(item.Links) > 0) { itemUpdated.links = item.Links; }
          
          return itemUpdated;
      }
  );
  result = ArrayHandler.sorter(result, 'order');

  return result;
};
const getLabID = (lab) => (lab ? lab.pathname ? lab.pathname : lab.id : false);


export default { getActiveLabIndex, getExplanationData, getLabID }
